<script setup>
  const props = defineProps({
    modelData: Object,
    breadcrumb: Array,
    joins: Object
  })
</script>

<template>
<div class="container-carrers">
  <div class="container">
    <div class="text">
      <div v-html="modelData.content"></div>
      <a :href="joins.slug">{{modelData.dynamicProperties['DP_link']}}</a>
    </div>
    <div class="image">
      <div class="content-image">
        <img :src="modelData.featured_image.fullUrl" alt="">
      </div>
    </div>
  </div>

</div>
</template>

<style scoped>

</style>
